
import {Component, Prop, Vue} from "vue-property-decorator";
import QrCodeReader from "@/components/QrCodeReader.vue";

@Component({
    components: {QrCodeReader},
})
export default class HandToHand extends Vue {
    private keyGroupId: number = null;
    private token: string = null;
    private keyGroup: any = null;
    private qrCodeReaderError: any = null;
    private loadingQrCodeStreamer: boolean = false;

    private mounted() {
        this.keyGroupId = Number(this.$route.params.keyGroupId);
        this.token = this.$route.params.token;
        this.getKeyGroupById();
    }

    private readQRCode(params: {token: string, moveAllSubObjects?: boolean}): Promise<any> {
        const {token} = params;
        this.qrCodeReaderError = null;
        this.loadingQrCodeStreamer = true;
        return this.$store.dispatch("KeyGroups/recoverHandToHand", {
            token,
            keyGroupId: this.keyGroupId,
        }).then((res) => {
            if (res.status === "OK") {
                this.$store.commit("alerts/displaySuccess", {
                    iconGroup: "icon-picto_recevoir-main-a-main",
                    msg: this.$i18n?.t("alerts.key.retrieveKeyGroupSuccess", {keyGroup: this.keyGroup.name}),
                });
                this.$router.push({name: "keys"});
            } else {
                this.$store.commit("alerts/displayError", {
                    iconGroup: "icon-picto_recevoir-main-a-main",
                    msg: this.$i18n?.t(`alerts.error.${res.status}`),
                });
                this.$router.push({name: "keys"});
            }
        }).catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: err,
            });
        }).finally(() => {
            this.loadingQrCodeStreamer = false;
        });
    }

    private getKeyGroupById(): Promise<any> {
        return this.$store.dispatch("keyGroups/getById", {
            keyGroupId: this.keyGroupId,
        }).then((res) => {
            this.keyGroup = res;
        }).catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: err,
            });
        });
    }

}
